import {request} from "./request";

export function StuGetNoTestInfo() {
  return request({
    url: 'student/StuGetNoTestInfo',
  })
}

export function GetNoTestInfo(id) {
  return request({
    url: 'student/GetNoTestInfo',
    params: {
      id
    }
  })
}

export function StuAddNoTest(img1, img2) {
  return request({
    url: 'student/StuAddNoTest',
    params: {
      img1, img2
    }
  })
}

export function DelStudentInNoTestById(id) {
  return request({
    url: 'student/DelStudentInNoTestById',
    params: {
      id
    }
  })
}

export function modifyStuInfoInNoTestById(id, passed, ranks, evaluation) {
  return request({
    url: 'student/modifyStuInfoInNoTestById',
    params: {
      id, passed, ranks, evaluation
    }
  })
}

export function GetNoTestCountByKey(key, years, status) {
  return request({
    url: 'student/GetNoTestCountByKey',
    params: {
      key, years, status
    }
  })
}

export function GetNoTestListLikeKeyByPage(key, years, status, page) {
  return request({
    url: 'student/GetNoTestListLikeKeyByPage',
    params: {
      key,
      page, years, status
    }
  })
}

export function GetNoTestDownLoad(type, years, status) {
  return request({
    method: 'post',
    url: 'student/GetNoTestDownLoad',
    params: {type, years, status},
    responseType: 'blob'
  })
}

export function DeleteNoTest(type, years, status) {
  return request({
    url: 'student/DeleteNoTest',
    params: {type, years, status},
  })
}
